import React from 'react'
import { Line } from 'react-native-svg'
import { territoryMarkerConnections } from './geometry'
import type { MapDef } from '@warcarp/api-types'

/** Classic Warfish graph: all adjacencies, including crossings, share one style. */
export const MarkerConnectionsLayer = React.memo(function MarkerConnectionsLayer({ territories, radius }: {
  territories: MapDef['territories']; radius: number
}) {
  const connections = React.useMemo(() => territoryMarkerConnections(territories, radius), [territories, radius])
  return <>{connections.map(({ key, from, to }) => <Line key={key} testID={`marker-connection-${key}`}
    x1={from.x} y1={from.y} x2={to.x} y2={to.y} stroke="#000000"
    strokeWidth={radius * 0.1} strokeDasharray={[radius * 0.45, radius * 0.3]}
    pointerEvents="none" />)}</>
})
